/* eslint-disable no-unused-vars */
import { Form as FormikForm, Formik } from 'formik';
import React from 'react';
import NButton from '../../components/inputs/NButton';
import NDropdown from '../../components/inputs/NDropdown';
import NInput from '../../components/inputs/NInput';
import { errorToaster, successToaster } from '../../components/toaster/Toaster';
import useNotificationAPI from '../../hooks/network/useNotificationAPI';
import { sendNotificationValidation } from '../../validations/validation';

const formInitialValues = {
  type: 'ALL',
  sendTo: 'all',
  ids: '',
  title: '',
  message: '',
};

export const SendNotification = () => {
  const { sendNotification } = useNotificationAPI();

  const handleFormSubmit = async (values) => {
    try {
      const payload = {
        sendToAll: values?.sendTo === 'all',
        type: values?.type,
        title: values?.title,
        message: values?.message,
      };

      if (values?.sendTo !== 'all') {
        payload[values?.sendTo] = values?.ids?.split(',');
      }

      const response = await sendNotification(payload);
      if (response?.success) {
        successToaster('Message Sent');
      }
    } catch {
      errorToaster('Something went wrong');
    }
  };

  return (
    <div>
      <Formik
        initialValues={formInitialValues}
        validationSchema={sendNotificationValidation}
        onSubmit={(values, formikBag) => {
          handleFormSubmit(values, formikBag);
        }}
        enableReinitialize
      >
        {({ handleSubmit, handleChange, handleBlur, values, errors, touched }) => (
          <FormikForm className='' autoComplete='off' onSubmit={handleSubmit}>
            <div className='mt-5 h-full min-h-[calc(100vh-100px)] rounded-lg bg-white px-5 pb-10 break:mx-20 break:px-10'>
              <div className='mb-5 border-b border-solid border-[#707070] py-4 break:mb-10'>
                <p className='font-semibold'> Send Notification</p>
              </div>
              <div className='flex w-full flex-col items-center justify-center'>
                <div className='w-full break:w-[50%]'>
                  <div className='grid w-full flex-auto auto-rows-max grid-cols-1 gap-10 rounded-2xl bg-white break:gap-x-32 xxl:grid-cols-1'>
                    <div className='w-full'>
                      <NDropdown
                        required
                        label='Type *'
                        name='type'
                        value={values.type}
                        onChange={(e) => handleChange(e)}
                        onBlur={handleBlur}
                        error={errors.type && touched.type}
                        helperText={errors.type && touched.type ? errors.type : ''}
                        className='w-full'
                        type='text'
                        options={[
                          { label: 'WEB', value: 'WEB' },
                          { label: 'APP', value: 'APP' },
                          { label: 'ALL', value: 'ALL' },
                        ]}
                      />
                    </div>
                    <div className='w-full'>
                      <NDropdown
                        required
                        label='Send To *'
                        name='sendTo'
                        value={values.sendTo}
                        onChange={(e) => handleChange(e)}
                        onBlur={handleBlur}
                        error={errors.sendTo && touched.sendTo}
                        helperText={errors.sendTo && touched.sendTo ? errors.sendTo : ''}
                        className='w-full'
                        type='text'
                        options={[
                          { label: 'All', value: 'all' },
                          { label: 'Login Ids', value: 'loginIds' },
                          { label: 'Project Ids', value: 'projectIds' },
                          { label: 'Customer Ids', value: 'customerIds' },
                        ]}
                      />
                    </div>
                    {values?.sendTo !== 'all' && (
                      <div className='w-full'>
                        <NInput
                          required
                          name='ids'
                          value={values.ids}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={errors.ids && touched.ids}
                          helperText={errors.ids && touched.ids ? errors.ids : ''}
                          className='w-full'
                          label={`${values.sendTo}`}
                          placeholder={`Comma separated ${values.sendTo}`}
                          type='text'
                          multiline
                          rows={3}
                        />
                      </div>
                    )}
                    <div className='w-full'>
                      <NInput
                        required
                        name='title'
                        value={values.title}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.title && touched.title}
                        helperText={errors.title && touched.title ? errors.title : ''}
                        className='w-full'
                        label={`Title`}
                        placeholder={`Title`}
                        type='text'
                        multiline
                        rows={2}
                      />
                    </div>
                    <div className='w-full'>
                      <NInput
                        required
                        name='message'
                        value={values.message}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={errors.message && touched.message}
                        helperText={errors.message && touched.message ? errors.message : ''}
                        className='w-full'
                        label={`Message`}
                        placeholder={`Message`}
                        type='text'
                        multiline
                        rows={7}
                      />
                    </div>
                  </div>

                  <div className='mt-5 flex items-center justify-center'>
                    <NButton isLoading={false} onClick={() => handleSubmit()} variant='Ncontained'>
                      Send Notification
                    </NButton>
                  </div>
                </div>
              </div>
            </div>
          </FormikForm>
        )}
      </Formik>
    </div>
  );
};
